import { ArrowLeft, ArrowRight } from '@digital-twins/design-system/icons'
import { cn } from '@/lib/utils'

interface HomeCarouselArrowButtonProps {
  direction: 'left' | 'right'
  onClick: () => void
  ariaLabel: string
  className?: string
}

export function HomeCarouselArrowButton({
  direction,
  onClick,
  ariaLabel,
  className,
}: HomeCarouselArrowButtonProps) {
  const Icon = direction === 'left' ? ArrowLeft : ArrowRight

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className={cn(
        'flex h-10 w-10 sm:h-8 sm:w-8 items-center justify-center rounded-full bg-white text-[hsl(var(--primary-dark))] shadow-home-float transition-transform duration-200 hover:-translate-y-0.5',
        className,
      )}
    >
      <Icon className="h-4 w-4" strokeWidth={1.8} />
    </button>
  )
}
